module.exports = __webpack_public_path__ + "static/media/icon-background.5afeb94e.svg";